import { getEnv } from "./env"

const PAAS_BASE_URL_MAP = {
  production: '//api.vhallyun.com',
  test: '//test01-api.vhallyun.com'
}

export const getPaasBaseUrl = () => {
  return PAAS_BASE_URL_MAP[getEnv()] || PAAS_BASE_URL_MAP.production
}